import { render } from "./arrow-horizontal.vue?vue&type=template&id=f8f851aa"
import script from "./arrow-horizontal.vue?vue&type=script&lang=js"
export * from "./arrow-horizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__